module.exports = __webpack_public_path__ + "static/media/cake1.a135215d.jpg";